import { t } from 'i18next'

export const required = (
  value, values, errorMessage = t('requiredField'),
) => !value && errorMessage

export const composeValidators = (...validators) => value => validators
  .reduce((error, validator) => error || validator(value), undefined)

export const createRangeValidator = (min, max, required = true) => value => {
  if (required && (value === undefined || value === null || value === '')) {
    return t('requiredField')
  }

  if (!required && (value === undefined || value === null || value === '')) {
    return undefined
  }

  const numValue = Number(value)

  if (Number.isNaN(numValue)) {
    return t('mustBeANumber')
  }

  if (numValue < min || numValue > max) {
    return `${t('valueMustBeBetween')} ${min} ${t('and')} ${max}`
  }

  return undefined
}
